"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.currencies = void 0;
exports.getCurrency = getCurrency;
exports.currencies = {
    en: 'usd',
    de: 'eur',
    es: 'eur',
    it: 'eur',
    pl: 'pln',
    zh: 'cny'
};
function getCurrency(lang) {
    return exports.currencies[lang] || 'usd';
}
